import gql from 'graphql-tag';

export const schema = gql`
  query GetPublicationBasicInformation($publicationId: String!) {
    getPropertyListingPublication(id: $publicationId) {
      __typename
      ... on GetPropertyListingPublicationSuccess {
        publication {
          id
          furnished: attribute(key: "basic_information/furnished") {
            furnished {
              value
            }
          }
          constructionYear: attribute(
            key: "basic_information/constructionYear"
          ) {
            constructionYear {
              value
            }
          }
          bathrooms: attribute(key: "basic_information/bathrooms") {
            bathrooms {
              value
            }
          }
          bedrooms: attribute(key: "basic_information/bedrooms") {
            bedrooms {
              value
            }
          }
          areaM2: attribute(key: "basic_information/areaM2") {
            areaM2 {
              value
            }
          }
          parkingSpaces: attribute(key: "basic_information/parkingSpaces") {
            parkingSpaces {
              value
            }
          }
          floor: attribute(key: "basic_information/floor") {
            floor {
              value
            }
          }
          stratum: attribute(key: "basic_information/stratum") {
            stratum {
              value
            }
          }
          petFriendly: attribute(key: "basic_information/pet_friendly") {
            petFriendly {
              value
            }
          }
        }
      }

      ... on GetPropertyListingPublicationFailure {
        error {
          code
          message
          metadata {
            key
            value
          }
        }
      }
    }
  }
`;
